// extracted by mini-css-extract-plugin
module.exports = {"sortSimple":"Xt_sortSimple__1cXWa"};